import { Inject, Injectable } from '@angular/core';
import { ENV_OPTIONS } from '@up/shared/injection-tokens';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderCacheDto } from '@up/data';

@Injectable({
  providedIn: 'root'
})
export class OrderCacheService {
  readonly API_KEY = 'order-cache';
  readonly API_URL = `${this.environmentOptions.apiUrl}/${this.API_KEY}`;

  constructor(
    @Inject(ENV_OPTIONS) private environmentOptions: any,
    private http: HttpClient
  ) {}

  public getByOrderLink(
    orderLink: string,
  ): Observable<Partial<OrderCacheDto>> {

    return this.http.get<OrderCacheDto>(this.API_URL +`/check-state-by-order-link/${orderLink}`);
  }

}